import { render, staticRenderFns } from "./ServiceProtocolPopup.vue?vue&type=template&id=32247e96&scoped=true"
import script from "./ServiceProtocolPopup.vue?vue&type=script&lang=js"
export * from "./ServiceProtocolPopup.vue?vue&type=script&lang=js"
import style0 from "./ServiceProtocolPopup.vue?vue&type=style&index=0&id=32247e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32247e96",
  null
  
)

export default component.exports